export default{
    baseDetails:{
        Notification:{
           
        },
        Message:{
            
        },
        Alert:{
            error:{
                title:'提示',
                text:'数据请求失败，请重试',
                buttonText:'确定',
            }
        },
        Button:{
            
        },
        Placeholder:{

        },
        Validate:{

        },
        Description:{
            title:'优选基地',
            module1:{
                text1:'基地面积：',
                text2:'亩',
                text3:'种植作物：',
                text4:'年  产 量：',
                text5:'公斤',
                text6:'年产值',
                text7:'万元',
                text8:'联  系 人：',
                text9:'联系方式：',
                text10:'联系地址：',
                button:'基地720云游',
            },
            module2:{
                title:'基地产品',
            },
            module3:{
                title:'基地介绍',
            },
            module4:{
                title:'基地视频',
            },
            module5:{
                title:'环境监测',
            }
        },
        Checkbox:{
            
        },
        Table:{

        },
        ValidData:{
            
        },
        InvalidData:{
            
        },
        Confirm:{
           
        },
        Dialog:{
            title:'基地云游'
        }
    }
    
}